<template>
  <div class="result d-flex-1 flex-column m-10">
    <div class="d-flex-1 flex-column">
      
    </div>
  </div>
</template>

<script>

export default {
  name: 'CommonTable',
  components: {  },
  data() {
    return {
      
    };
  },
  props: {
   
  },
  async created() {
    
  },
  async mounted() {
   
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>